var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"loldocup-home":""}},[_c('HomeHeader'),_c('LoldocupLeague'),_c('client-only',[_c('MyInfo')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }